<template>
  <header class="flex items-center text-white bg-primary">
    <RouterLink
      :to="{ name: 'Dashboard' }"
      tag="div"
      class="h-full flex pl-20 pr-5 cursor-pointer tablet:w-sidebar tablet:px-25"
    >
      <img
        src="/images/eventor-icon.svg"
        alt="Eventor"
        class="max-w-22 mt-0 tablet:hidden"
      >
      <img
        src="/images/eventor-logo.svg"
        alt="Eventor"
        class="hidden mt-4 tablet:block"
      >
    </RouterLink>

    <NavigationTitle class="flex-1 px-20 text-left font-normal tablet:px-30" />

    <UserAccount class="pr-20 tablet:pr-30 laptop:pr-35" />
  </header>
</template>

<script>
import UserAccount from '@/components/UserAccount';
import NavigationTitle from '@/components/navigation/NavigationTitle';

export default {
  components: {
    UserAccount,
    NavigationTitle,
  },
};
</script>

<style>
</style>
